Namespace 'Customer.Ticket'

class Customer.Ticket.ResponseExistingAttachmentLabelView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/attachment/response_attachment_label']
  className: 'response-upload-attachment'

  initialize: ({attachment, file}) =>
    @attachment = attachment
    @file = file

  render: =>
    @$el.html(@template(filename: @filename(), fileSize: @fileSize()))
    @$el = @$el.children().first()
    @$el.find('i.icon-remove').click(@destroy)
    @$el.find('.loading-attachment').remove()
    @

  filename: =>
    @file.name

  fileSize: ()->
    '' # We don't know the size of existing attachments

  destroy: =>
    @trigger('remove:attachment')
    @attachment.deleteExistingAttachment(@)
    @remove()
